import React from "react";
import { Box } from "@mui/material";

interface StackedCardsProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  itemWidth?: number;
  itemHeight?: number;
  offsetX?: number;
  offsetY?: number;
  limit?: number;
}

export function StackedCards<T>({
  items,
  renderItem,
  itemWidth = 48,
  itemHeight = 48,
  offsetX = 5,
  offsetY = 3,
  limit = 3,
}: StackedCardsProps<T>) {
  if (!items || items.length === 0) return null;

  const visibleItems =
    limit && items.length > limit ? items.slice(0, limit) : items;

  const width = (visibleItems.length - 1) * offsetX + itemWidth;
  const height = (visibleItems.length - 1) * offsetY + itemHeight;

  return (
    <Box
      sx={{
        position: "relative",
        width: `${width}px`,
        height: `${height}px`,
        margin: "0 auto",
        display: "block",
      }}
    >
      {visibleItems.map((item, index) => (
        <Box
          key={index}
          sx={{
            position: "absolute",
            left: `${index * offsetX}px`,
            top: `${index * offsetY}px`,
            zIndex: visibleItems.length - index,
          }}
        >
          {renderItem(item, index)}
        </Box>
      ))}
    </Box>
  );
}
